import React from 'react';

/** Lotus-mandala motif in the costume jewel tones. viewBox -60..60. */
const petals = ['#D62E80', '#F5A524', '#1FA89F', '#3D6FE0', '#E2394B', '#F5A524', '#1FA89F', '#5B5BD6'];
export function SeedPaths() {
  return <g data-id="element-280" data-mp="2ikluqxuie8ad">
      {petals.map((fill, i) => <ellipse key={i} cx={0} cy={-30} rx={11} ry={24} fill={fill} opacity={0.9} transform={`rotate(${i * 45})`} data-id="element-281" data-mp="2ijsl9p4614oj" data-mpi={i} />)}
      <circle r={16} fill="#F5A524" data-id="element-282" data-mp="2wd1vtt3unw8n" />
      <circle r={9} fill="#A51C62" data-id="element-283" data-mp="2wc0itj39wzoa" />
      <circle r={3.5} fill="#FBF6EE" data-id="element-284" data-mp="2wf4qwrjv0fk8" />
    </g>;
}
export function Seed({
  className = ''
}: {
  className?: string;
}) {
  return <svg aria-hidden="true" viewBox="-60 -60 120 120" className={className} data-id="element-285" data-mp="36ay1i5e0pyzd">
      <SeedPaths data-id="element-286" data-mp="368vdfqwfefxa" />
    </svg>;
}